module.exports = __webpack_public_path__ + "static/media/vidal9.876f27e3.png";